export const PAPER_FORMAT = "application/pdf"; // this is the format for the paper to be uploaded

export const USER_EXPERIENCE = [
  // this is the experience of the user
  { id: 1, duration: "0 years" },
  { id: 2, duration: "1-2 years" },
  { id: 3, duration: "3-5 years" },
  { id: 4, duration: "6-10 years" },
  { id: 5, duration: "11-15 years" },
  { id: 6, duration: "16+ years" },
  { id: 7, duration: "Varies" },
];

export const CURRENCY_OPTIONS = [
  { label: "USD ($)", value: "USD", symbol: "$" },
  { label: "EUR (€)", value: "EUR", symbol: "€" },
  { label: "GBP (£)", value: "GBP", symbol: "£" },
  { label: "LKR (₨)", value: "LKR", symbol: "₨" },
  { label: "INR (₹)", value: "INR", symbol: "₹" },
];